<template>
    <b-field
      :label="label"
      :type="inputType"
      :message="errorMessage"
      :class="{ required: isRequired }"
    >
      <b-autocomplete
        :data="data"
        :field="field"
        ref="autoComplete"
        @typing="getData"
        @select="onSelect"
        :disabled="disabled"
        :loading="isFetching"
        :placeholder="placeholder"
        :append-to-body="appendToBody"
        :dropdown-position="dropdownPosition"
        :keep-first="keepFirst !== undefined ? keepFirst : true"
      ></b-autocomplete>
    </b-field>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';

export default {
  props: {
    label: String,
    getter: Function,
    setter: Function,
    placeholder: String,
    field: String,
    keepFirst: Boolean,
    isRequired: Boolean,
    errors: {
      type: Array,
      default: () => [],
    },
    value: {
      type: null,
    },
    flag: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropdownPosition: {
      type: String,
      default: () => 'bottom',
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'model',
    event: 'select',
  },
  data: () => ({
    innerValue: null,
    selected: null,
    data: [],
    staticData: [],
    isFetching: false,
  }),
  computed: {
    inputType() {
      if (this.errors && this.errors.length) return 'is-danger';
      return null;
    },
    errorMessage() {
      if (!this.errors || !this.errors.length) return null;
      return this.errors[0];
    },
    ...mapGetters(['clinicId']),
  },
  methods: {
    onSelect(option) {
      this.flag === 'bank' && this.$emit('select', option ? option.bank_number : null);
      !['bank', 'patient'].includes(this.flag) && this.$emit('select', option ? option.id : null);
      this.flag === 'patient' && this.$emit('select', option ? option : null);
    },
    getData(name) {
      this.flag === 'crm' && this.getStaticData(name);
      this.flag !== 'crm' && this.getAsyncData(name);
    },
    getStaticData(name) {
      if (!name) {
        this.data = this.staticData;
      }

      this.data = this.staticData.filter((opt) => {
        return opt.name.toLowerCase().indexOf(name.toLowerCase()) >= 0;
      });
    },
    getAsyncData: debounce(function (name) {
      if (!name.length) {
        this.data = [];
        return;
      }

      this.isFetching = true;
      this.getter(name, { clinic_id: this.clinicId })
        .then(({ data }) => (this.data = [...data]))
        .catch(() => (this.data = []))
        .finally(() => {
          this.isFetching = false;
        });
    }, 500),
    checkInArray(value) {
      const idx = this.data.findIndex((el) => el.id == value);
      if (idx === -1) this.loadResourceById(value);
    },
    loadResourceById(id) {
      if (!id) return;
      this.isFetching = true;

      this.setter(id)
        .then(({ data: resource }) => {
          this.data = [resource];
          this.$refs.autoComplete.setSelected(resource);
        })
        .finally(() => (this.isFetching = false));
    },
  },
  mounted() {
    if (this.flag === 'crm') {
      this.getter('')
        .then(({ data }) => (this.staticData = [...data]))
        .catch(() => (this.staticData = []));
    }

    this.innerValue = this.value;
    if (this.innerValue) this.checkInArray(this.innerValue);
  },
};
</script>